module.exports = __webpack_public_path__ + "static/impact_a11y_ultimate_experience-dea9dd1d1be99f0ce7ef6474fd39c09b.png";